import { categories } from '@/mocks/homeData';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Browse <span className="text-primary-600">Product Categories</span>
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto">
            Explore all categories in the Basetao Spreadsheet and discover trending products across every style.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200 hover:border-primary-300 hover:shadow-md transition-all duration-200 cursor-pointer overflow-hidden"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-100">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
              </div>
              <div className="flex items-center gap-2 px-3 py-3">
                <span className="w-7 h-7 flex items-center justify-center rounded-lg bg-primary-100 group-hover:bg-primary-200 transition-colors flex-shrink-0">
                  <i className={`${cat.icon} text-sm text-primary-600 group-hover:text-primary-700`}></i>
                </span>
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 leading-tight">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}